import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { Info } from 'lucide-react';

/**
 * A small (i) icon that explains the control next to it on hover or focus.
 * Keep the text short and plain, with an example where it helps.
 */
const InfoTip = ({ title, size = 15, placement = 'top' }) => (
  <Tooltip title={title} placement={placement} arrow>
    <Box
      component="span"
      tabIndex={0}
      aria-label={typeof title === 'string' ? title : undefined}
      sx={{ display: 'inline-flex', color: 'text.secondary', cursor: 'help', verticalAlign: 'middle' }}
    >
      <Info size={size} />
    </Box>
  </Tooltip>
);

export default InfoTip;
